import React from 'react';
import './Loading.scss';

const Loading = (props) => {
  const { show = false, backdrop = false, classNames = [], } = props;
  return (
    <div className={['app-loading-spinner-wrapper', ...classNames].join(' ')} hidden={!show}>
      <div className='app-loading-spinner'></div>
      { backdrop ? <div className='app-loading-spinner-backdrop' /> : void 0 }
    </div>
  );
};

export default Loading;
